import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=940d45a4&scoped=true"
import script from "./Broadcast.vue?vue&type=script&lang=js"
export * from "./Broadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940d45a4",
  null
  
)

export default component.exports